// Common routes are routes we want shared between all game versions

export const commonRoutes = {
  Home: '/',

  CookiesPolicy: '/cookies-policy',
  PrivacyPolicy: '/privacy-policy',
  TermsOfService: '/terms-of-use',
  ModerationPolicy: '/moderation-policy',
  SecurityDisclosure: '/security',
  PoliciesUpdated: '/policies-updated',

  RealmHome: '/home/:region/:realm',
  RegionHome: '/home/:region',

  RaidGlobalCoverage: '/:raid/global-coverage',
  RaidWorldFirstTracker: '/:raid/race-tracker',
  RWFAnalyzerPage: '/:raid/analyze',

  RaidHallOfFame: '/:raid/hall-of-fame/:region/:difficulty/:faction?',
  RaidFactionHallOfFame: '/:raid/faction-hall-of-fame/:region/:difficulty/:faction',
  RaidRealmHallOfFame: '/:raid/realm-hall-of-fame/:region/:realm/:difficulty/:faction?',

  RaidRankings: '/:raid/rankings/:region/:difficulty/:page?',
  RaidRealmRankings: '/:raid/realm-rankings/:region/:realm/:difficulty/:page?',
  RaidFactionRankings: '/:raid/faction-rankings/:region/:difficulty/:faction/:page?',
  RaidFactionRealmRankings: '/:raid/faction-realm-rankings/:region/:realm/:difficulty/:faction/:page?',

  BossRankings: '/:raid/boss-rankings/:boss/:region/:difficulty/:page?',
  BossFactionRankings: '/:raid/boss-faction-rankings/:boss/:region/:difficulty/:faction/:page?',
  BossRealmRankings: '/:raid/boss-realm-rankings/:boss/:region/:realm/:difficulty/:page?',
  BossFactionRealmRankings: '/:raid/boss-faction-realm-rankings/:boss/:region/:realm/:difficulty/:faction/:page?',

  ProgressRankings: '/:raid/progress-rankings/:progress/:region/:difficulty/:page?',
  ProgressRealmRankings: '/:raid/progress-realm-rankings/:progress/:region/:realm/:difficulty/:page?',
  ProgressFactionRankings: '/:raid/faction-progress-rankings/:progress/:region/:difficulty/:faction/:page?',
  ProgressFactionRealmRankings:
    '/:raid/faction-realm-progress-rankings/:progress/:region/:realm/:difficulty/:faction/:page?',

  ConnectedRealms: '/realms/:region?',

  GuildDetails: '/guilds/:region/:realm/:guild',
  GuildRoster: '/guilds/:region/:realm/:guild/roster',
  GuildStats: '/guilds/:region/:realm/:guild/stats/:type?',
  GuildCharacterAchievementLeaderboard: '/guilds/:region/:realm/:guild/achievements/:tier',
  GuildCharacterKeystoneLeaderboard: '/guilds/:region/:realm/:guild/mythic-plus-characters/:season',
  GuildRaidComposition: '/guilds/:region/:realm/:guild/raid-encounters/:difficulty/:raid/:boss',
  GuildRecruitmentPage: '/guilds/:region/:realm/:guild/recruitment',

  CharacterDetails: '/characters/:region/:realm/:character',
  CharacterRecruitmentPage: '/characters/:region/:realm/:character/recruitment',
  CharacterStats: '/characters/:region/:realm/:character/stats/:type?',

  RaidLoggedEncounter: '/raid-logged-encounters/:raid/:id',

  // while this is M+, it's needed in some common code
  MythicKeystoneLoggedRun: '/mythic-plus-logged-runs/:season/:id',

  Login: '/login',
  Register: '/register',
  RegisterSuccess: '/verify/email',
  RegisterError: '/verify/error',
  RegisterVerified: '/verify/success',
  RegisterPendingPage: '/verify/pending',
  TwoFactorAuth: '/verify/mfa',

  ForgotPasswordTriggered: '/verify/reset',

  Advertise: '/advertise',
  Branding: '/branding',
  Addon: '/addon',
  Premium: '/premium/:type?',
  Recruitment: '/recruitment',
  Discord: '/discord/:type?',
  Widget: '/widgets',

  ForgotPassword: '/login/forgot',
  ResetPasswordSuccess: '/reset/success',
  ResetPassword: '/reset',

  UserCharacterPrivacySettings: '/settings/characters/:character_id/privacy',
  UserCharacterProfileSettings: '/settings/characters/:character_id/profile',
  UserCharacterTransferSettings: '/settings/characters/:character_id/transfer',
  UserCharacterAddonSettings: '/settings/characters/:character_id/addon',

  UserGroupRoleSettings: '/settings/groups/:group_id/roles',
  UserGroupBlockListSettings: '/settings/groups/:group_id/block-list',
  UserGroupPrivacySettings: '/settings/groups/:group_id/privacy',
  UserGroupSettings: '/settings/groups/:group_id/profile',
  UserGroupClientUsage: '/settings/groups/:group_id/client-usage/:token?',

  // message center
  MessageCenterHomePage: '/messages',
  MessageCenterThread: '/messages/threads/:thread_id',

  // recruitment(v2)
  RecruitmentProfileCreate: '/settings/recruitment/profiles/create',
  UserRecruitmentProfiles: '/settings/recruitment/profiles/:filter?',
  RecruitmentProfileConfig: '/settings/recruitment/profile/:profile_id/:step?',

  UserSettings: '/settings',
  UserBattleNetSettings: '/settings/battlenet',
  UserDeleteAccountSettings: '/settings/delete-account',
  UserEmailSettings: '/settings/email',
  UserTwoFactorAuth: '/settings/two-factor-authentication',
  UserPasswordSettings: '/settings/password',
  UserPatreonSettings: '/settings/patreon',
  UserPremiumSettings: '/settings/vanity-alias',
  UserTimeSettings: '/settings/time',
  UserProfileSettings: '/settings/profile',
  UserBlockList: '/settings/block-list',
  UserSocialSettings: '/settings/social',
  UserNotificationSettings: '/settings/notifications',
  UserUsernameSettings: '/settings/username',
  UserAddonSettings: '/settings/addon',

  // group charter stuff
  CreateGroupCharterSettings: '/settings/groups/create',
  ViewGroupCharterSettings: '/settings/groups/:group_id/roster',
  RenameGroupCharterPage: '/settings/groups/:group_id/rename',
  GroupCharterInvite: '/invite/:code',

  // Client
  ClientLiveTrackingException: '/client/live-tracking-exception',

  Search: '/search',

  CharacterSnapshot: '/embeds/characters/:mode/:id/:timestamp',
  GuildSnapshot: '/embeds/guilds/:mode/:id/:timestamp',

  MarkdownHelp: '/docs/markdown',

  StreamEmbedBossPullsFeedWidget: '/widgets/boss-pulls-feed',
  StreamEmbedBossProgressWidget: '/widgets/boss-progress',
  StreamEmbedBossProgressWidgetGallery: '/widgets/boss-progress/gallery/:raid/:boss?',
  StreamEmbedRwfEventFeedWidget: '/widgets/rwf-event-feed',
  StreamEmbedHealthOverAttemptWidget: '/widgets/health-over-attempt',
  StreamEmbedVersusWidget: '/widgets/raid-versus',
  StreamEmbedVersusTimelineWidget: '/widgets/raid-versus-timeline',
  StreamEmbedRaidLeaderboardWidget: '/widgets/raid-leaderboard',

  StreamEmbedRwfGuildLoot: '/widgets/guild-loot',
  StreamEmbedCompBreakdown: '/widgets/guild-gear-composition',
  StreamEmbedGuildGearComparison: '/widgets/guild-gear-comparison',
  StreamEmbedGuildPullsComparison: '/widgets/guild-pulls-comparison',

  // User Profile
  UserProfile: '/user/:name',

  /**
   * Team
   */
  TeamDetails: '/teams/:region/:team',

  // events
  EventsManagement: '/event-manager/events',
  EventCollectionList: '/event-manager/collections',
  EditEventCollectionDetails: '/event-manager/collections/:id/edit',
  EventCollectionEventList: '/event-manager/collections/:id/events',
  EventCollectionVideos: '/event-manager/collections/:id/videos',
  CreateEventCollection: '/event-manager/collections/create',
  CreateEvent: '/event-manager/events/create',
  CreateLegacyEvent: '/event-manager/events/create/legacy',
  EditEvent: '/event-manager/events/:slug',
  EditLegacyEvent: '/event-manager/events/:slug/legacy',
  CreateEventBracket: '/event-manager/events/:slug/brackets/create',
  EditEventBracketDetails: '/event-manager/events/:slug/brackets/:bracketSlug',
  EditEventBracketTeams: '/event-manager/events/:slug/brackets/:bracketSlug/teams',
  EditEventBracketMatches: '/event-manager/events/:slug/brackets/:bracketSlug/matches',
  PreviewEventBracket: '/event-manager/events/:slug/brackets/:bracketSlug/preview',
  EditEventBracketMatchDetails: '/event-manager/events/:slug/brackets/:bracketSlug/matches/:matchId/:gameId?',
  EventRegister: '/events/:slug/register',
  EventTeams: '/events/:slug/teams',
  EventBrackets: '/events/:slug/brackets/:bracketSlug?',
  EventBracketsPlunderstormRoyale: '/events/:slug/leaderboard-royale/:bracketSlug?/:game?',
  EventBracketsTimeTrialsDungeons: '/events/:slug/bracket-dungeons/:bracketSlug?',
  EventBracketsTimeTrialsTeams: '/events/:slug/bracket-leaderboard/:bracketSlug?/:page?',
  EventBracketsStandardRuns: '/events/:slug/bracket-standard-runs/:bracketSlug?/:page?',
  EventBracketsStandardTeams: '/events/:slug/bracket-standard-leaderboard/:bracketSlug?/:page?',
  EventBracketsTheGreatPush: '/events/:slug/the-great-push/:bracketSlug?',
  EventBracketsTheGreatPushLeaderboard: '/events/:slug/the-great-push-leaderboard/:bracketSlug?',
  EventBracketsBreakTheMetaRuns: '/events/:slug/break-the-meta-runs/:bracketSlug/:dungeon/:region/:page?',
  EventBracketsBreakTheMetaClasses:
    '/events/:slug/break-the-meta-classes/:bracketSlug/:season/:region/:class/:role/:page?',
  EventSection: '/events/:slug/:sectionSlug?',
  EventTeamDetails: '/event-teams/:namespace/:team',

  // tournaments
  BlizzardTournaments: '/legacy-tournaments/:mode?',
  CommunityEvents: '/community-events/:mode?',
  TournamentsHub: '/tournaments/:esportType?',

  EventStandings: '/event-insights/standings',
  EventInsights: '/event-insights/statistics',

  // Statistics
  Statistics: '/stats/:type?'
};
